/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'

class AddLocationStatus extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }
  componentDidMount() {}

  addLocationStatus() {
    var deliveryLocationName = document.getElementById('name').value
    var enabled = document.getElementById('enabled').value
    var nameError = false
    var enableError = false
    var formError = false
    if (deliveryLocationName == '') {
      formError = true
      nameError = true
      message.error('نام وضعیت وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (enabled == '') {
      formError = true
      enableError = true
      message.error('وضعیت را مشخص کنید')
    } else {
      if (!enableError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        deliveryLocationName,
        enabled
      }

      http
        .post(`${ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_ADD}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('محل تحویل جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/base/orderStatus/reportLocationStatus')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>وضعیت سفارشات</li>
            <li>
              <Link to={'/base/orderStatus/reportOrderStatus'}>لیست محل های تحویل</Link>
            </li>
            <li>افزودن محل تحویل</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت محل تحویل</p>
            </div>
            <div className="formComponent">
              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="name" className="form-control" />

              <label>
                وضعیت فعال <span className="requireFiled">*</span>
              </label>
              <select className="form-control" name="enabled" id="enabled">
                <option value="">------</option>
                <option value={1}>فعال</option>
                <option value={0}>غیر فعال</option>
              </select>

              <button className="btn btn-info btn-block" onClick={this.addLocationStatus.bind(this)}>
                ثبت محل تحویل
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddLocationStatus
